// tslint:disable:max-line-length
import * as React from "react";
import { iconStyle } from './icon.style';
interface IProps {
  style?: React.CSSProperties;
}
export const CheckmarkRoundCheckedIcon: React.FC<IProps> = (props) =><svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{...iconStyle, ...props.style}}>
  <path d="M12,24C5.38,24,0,18.62,0,12S5.38,0,12,0s12,5.38,12,12-5.38,12-12,12ZM12,2C6.49,2,2,6.49,2,12s4.49,10,10,10,10-4.49,10-10S17.51,2,12,2ZM10.84,17.21c.58-.04,1.11-.34,1.46-.81l5.91-8.06c.33-.45.23-1.07-.21-1.4-.45-.33-1.07-.23-1.4.21l-5.91,8.06-3.38-3.38c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l3.38,3.38c.38.38.89.59,1.41.59.05,0,.1,0,.15,0Z"/>
</svg>


// WEBPACK FOOTER //
// ./src/icons/Checkmark-circle-line.tsx